<!--<div [ngClass]="{ 'divider': config?.divider }" class="">-->
<ng-content></ng-content>
<!--</div>-->
